<template>
  <div class="maintenance">
    <h1 class="text-3xl bold">
      {{ $t('text.dearUser') }}
    </h1>
    <h2 class="text-xl">
      {{ $t('text.maintenance') }}
    </h2>
  </div>
</template>

<script>
export default {
  name: 'Maintenance'
};
</script>

<style lang="scss" scoped>
.maintenance {
  text-align: center;
  padding: 15px;
  display:grid;
  grid-gap: 2rem;
  max-width: 600px;
  margin: 3rem auto;
}
</style>
